import React from "react";
import { Container } from "react-bootstrap";

const ExtraSectioin = () => {
  return (
    <Container className="py-5 mt-5" id="extra_section">
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <img
            src="https://www1.djicdn.com/cms/uploads/70e091df66d57745608d5c0674ed8a4e@1x.webp"
            width="100%"
            alt=""
          />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 pl-3">
          <h2 className="">Who we are</h2>
          <p className=" text-muted pl-5">
            Manefish Billfish bluntnose minnow yellowfin grouper yellowtail
            amberjack emperor. Pelagic cod morid cod Raccoon butterfly fish
            whiptail gulper cuchia cow shark pollyfish. X-ray tetra, saury queen
            danio Ragfish Red whalefish lamprey poolfish combtooth blenny;
            jackfish
          </p>
          <button className="btn btn-warning">Read More</button>
        </div>
      </div>
    </Container>
  );
};

export default ExtraSectioin;
